import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Grid from '../../grid/Grid';
import VerticalLabelList from '../../label/VerticalLabelList';
import FieldSet from '../../fieldset/FieldSet';

const EbillingEnrollmentDetail = ({ selectedAccount, }) => {
  const renderEnrollmentInformation = () => {
    const formattedAccount = Object.keys(selectedAccount)
      .filter(key => !!selectedAccount[key])
      .reduce((obj, key) => {
         
        obj[_.startCase(key)] = selectedAccount[key];
        return obj;
      }, {});
    const items = VerticalLabelList.toList(formattedAccount);
    const exclusions = [ 'Enrollment History Items', ];

    return (
      <FieldSet title="eBilling Enrollment" style={{ maxHeight: '400px', }}>
        <VerticalLabelList items={items} exclusions={exclusions} />
      </FieldSet>
    );
  };

  const renderEnrollmentHistoryItems = () => {
    const historyItemModel = Grid.toModelFromList(selectedAccount.enrollmentHistoryItems, {
      headerFormatter: value => _.startCase(value.header),
    });
    const rows = historyItemModel.format(selectedAccount.enrollmentHistoryItems);

    return (
      <FieldSet title="Enrollment History Items" style={{ maxHeight: '400px', }}>
        <Grid
          headers={historyItemModel.headers}
          rows={rows}
        />
      </FieldSet>
    );
  };

  return (
    <>
      {renderEnrollmentInformation()}
      {renderEnrollmentHistoryItems()}
    </>
  );
};

EbillingEnrollmentDetail.propTypes = {
  selectedAccount: PropTypes.instanceOf(Object).isRequired,
};

export default EbillingEnrollmentDetail;
